import React from 'react';
import './Header.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Nav, Navbar } from 'react-bootstrap';
const Header = () => {
    return (
        <nav className='header'>
            <Navbar className='p-3' collapseOnSelect expand="lg" bg="success" variant="dark">
                <Container>
                    <Navbar.Brand href="#">Fashion Hub</Navbar.Brand>
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className="me-auto">

                        </Nav>
                        <Nav>
                            <Nav.Link className='text-white' href="#">Home</Nav.Link>
                            <Nav.Link href="#">About Us</Nav.Link>
                            <Nav.Link href="#">Mobiles</Nav.Link>
                            <Nav.Link href="#">Contact Us</Nav.Link>

                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>



        </nav>
    );
};

export default Header;